export default __webpack_public_path__ + "static/hero-a05f35e95551b12db294d8ca3a50ebe7.png";